export interface Box {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

// 데스크톱 창(DesktopWindow·HoloPane 틀)과 모바일 전체화면 창. 최소화된 창은 display:none 이라 크기가 0 이다.
export const WINDOW_SURFACE_SELECTOR = '[data-window-frame], [data-mobile-window-takeover]';

/**
 * bounds 중 rects 가 덮은 비율(0~1). 겹친 창을 두 번 세지 않도록 격자 점 표본으로 합집합을 잰다.
 * ponytail: 40×24 점이라 해상도는 bounds 폭의 1/40 — 창 가장자리 몇 px 오차는 기준(80%) 판정에 무관하다.
 */
export function coveredFraction(rects: Box[], bounds: Box, cols = 40, rows = 24): number {
  const w = bounds.right - bounds.left;
  const h = bounds.bottom - bounds.top;
  if (w <= 0 || h <= 0 || rects.length === 0) return 0;
  let hit = 0;
  for (let r = 0; r < rows; r++) {
    const y = bounds.top + ((r + 0.5) * h) / rows;
    for (let c = 0; c < cols; c++) {
      const x = bounds.left + ((c + 0.5) * w) / cols;
      if (rects.some((b) => x >= b.left && x < b.right && y >= b.top && y < b.bottom)) hit++;
    }
  }
  return hit / (cols * rows);
}
